

import * as _ from "lodash";
import { QuestionType } from "../../client/js/utils/AppConstants";

export default class ValidationUtils {
    static checkValidations = (value: any, fields: any, attributeName: string) => {
        let validation: any = {};
        fields.forEach((type:any) => {
            if(type.validator && value.hasOwnProperty(type[attributeName])) {
                validation[type[attributeName]] = ValidationUtils.checkValidationType(value[type[attributeName]], type.validator);
            } else {
                validation[type[attributeName]] = {result: true, errorMessage: ""}
            }
        });
        return validation;
    }
    static checkRequiredValidation = (value: any) => (!value) ? { result: false, errorMessage: "The field should not be empty" } : { result: true, errorMessage: "" };

    static checkRegExValidation(
        value: any, pattern: string) {
        let matchingPattern = new RegExp(pattern);
        var regexValidationResult = { result: true, errorMessage: "" };
        value.match(matchingPattern) ? regexValidationResult = { result: true, errorMessage: "" }
            : regexValidationResult = { result: false, errorMessage: "Please enter a valid value" };
        return regexValidationResult;
    }

    static checkTypeValidation(type: string, value: any) {
        switch(type) {
            case "number":
                return this.checkNumber(value);
            case "string":
            case "boolean": {
                if (typeof(value) !== type) {
                    return { result: false, errorMessage: `Please enter a valid ${type} value` };
                
                }
                return { result: true, errorMessage: "" };
            }
            default: return {result: true, errorMessage: ""}
        }
    }

    static checkValidationType(value: any, validator: any) {
        var resultOfValidation = { result: true, errorMessage: '' };
        if (validator) {
            // if (validator.required) {
            //     resultOfValidation = this.checkRequiredValidation(value);
            // }
            if (resultOfValidation.result && validator.pattern) {
                resultOfValidation = this.checkRegExValidation(value, validator.pattern);
            }
            if (resultOfValidation.result && validator.type) {
                resultOfValidation = this.checkTypeValidation(validator.type, value);
            }
            if (resultOfValidation.result && validator.minimumValue) {
                resultOfValidation = this.checkMinimumValue(value, validator.minimumValue);
            }
            if (resultOfValidation.result && validator.minLength && validator.maxLength) {
                resultOfValidation = this.checkMinMaxLength(value, validator.minLength, validator.maxLength);
            }
        }
        return resultOfValidation;
    }
    static checkNumber = (value: any) => {
        var regexValidationResult = {};
        if(isNaN(value) ){
            return regexValidationResult = { result: false, errorMessage: "Please enter a numeric value" };

        } else {
            return regexValidationResult = { result: true, errorMessage: "" };
        }
    }

    static checkMinimumValue = (value: any, minimumValue: number) => (value >= minimumValue) ? {result: true, errorMessage: ""} : {result: false, errorMessage: "The value should not be greater than the minimum value"}

    static checkMinMaxLength = (value: any, minLength: number, maxLength: number) => {
        var regexValidationResult = {};
        if(value.length >= minLength && value.length <= maxLength){
            return regexValidationResult = {result: true, errorMessage: ""};
        }
        else{
            return regexValidationResult = {result: false, errorMessage: "Input the value between "+ minLength + " and " + maxLength +" characters"};
        }
    }

    static getSchemaValidators(schema: any, validationObj: any, key: string) {
    /* 
        Read json schema obtained from uiConfig and create validationObj using which validator for each
        item can be injected into the uiConfig.
    */
        if (schema.type === "object" && schema.properties) {
            let propList = Object.keys(schema.properties);
            propList.map((propKey) => {
                if (propKey) {
                    validationObj[propKey] = {};
                    if (schema.required && schema.required.length > 0 && schema.required.includes(propKey)) {
                        validationObj[propKey]["required"] = true;
                    }
                    ValidationUtils.getSchemaValidators(schema.properties[propKey], validationObj[propKey], propKey);
                }
            });
        } else if (schema.type === "array") {
            ValidationUtils.getSchemaValidators(schema.items, validationObj, key);
        } else {
            Object.assign(validationObj, schema);
        }
    }

    static injectValidators(row: any, validationObject: any) {
    /* 
        Read validation form validation Object created by calling getSchemaValidators() method 
        and inject the validator on the item level in uiConfig of a particular section.
    */
        if (row.answerList || row.fields) {
          let rowList = row.answerList || row.fields;
          rowList.map((answerList: any) => {
            if (answerList.type === QuestionType.QUESTIONNAIRE || answerList.type === QuestionType.TEMPLATED_LIST) {
              let answerTypeList = answerList.type === QuestionType.QUESTIONNAIRE ? answerList.data: answerList.fields;
              answerTypeList.map((item: any) => {
                let key = item.key || "items" ;
                if(validationObject && validationObject[key]) {
                    ValidationUtils.injectValidators(item, validationObject[key]) 
                }
              })
          } else {
            let validator = {validator: validationObject ? (answerList.key ? validationObject[answerList.key]: validationObject) : {}
            }
            Object.assign(answerList, validator);
          }
          })
        } else {
            let validator = {validator: validationObject}
            Object.assign(row, validator);      
        }
    }

    static injectValidationKeys(uiConfig: any) {
        uiConfig.map((section: any) => {
            if (section.validationSchema) {
                let validationObject: any = {};
                ValidationUtils.getSchemaValidators(section.validationSchema, validationObject, section.subSectionKey);
                section.data.map((row: any) => {
                    if (validationObject && validationObject[row.key]) {
                        ValidationUtils.injectValidators(row, validationObject[row.key])
                    }
                })
            }
        });
    }
}
